<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'RegisterAdverseEvents',
    mounted() {
      window.livewire.on('adverseEventRegistered', (event) => {
        $('#register-adverse-event-modal').modal('hide')
        console.log(event)
      })
    }
  }
</script>
